import { SiGooglemaps, SiZalo } from "react-icons/si";
import { FaFacebookSquare } from "react-icons/fa";
import { FaSquareInstagram } from "react-icons/fa6";


function Contact(){
  return(
    <>
    <div className="flex flex-col text-lg items-center text-center text-brown space-y-1 cochin">
      <h1 className="mt-5 mb-8 text-3xl font-bold arial">Contact</h1>
      <p>datsontattoos@gmail.com</p>
      <p>+84 778426523</p>
      <p>11:00 AM - 08:00 PM</p>
      <div className="flex space-x-6">
        <a href="https://www.instagram.com/datson.tattoos?fbclid=IwY2xjawEWuBFleHRuA2FlbQIxMAABHTuPsyFD2gCtRJGSGqzTsYfsl-VVMsNhCZLM678CEACXWdKN0031g8cYUw_aem_oXN2G5sgcAAHadw-s-g90g" target="blank">  
        <FaSquareInstagram size={40}/>
        </a>
        <a href="https://www.facebook.com/datsontattoos" target="blank">
        <FaFacebookSquare size={40}/>
        </a>
        <a href="https://zalo.me/0778426523" target="blank">
        <SiZalo size={40}/>
        </a>
        <a href="https://www.google.com/maps/dir/21.4089267,-157.9651372/10.8702674,106.5954099/@1.2024023,68.4744594,18916375m/data=!3m2!1e3!4b1!4m4!4m3!1m1!4e1!1m0?entry=ttu" target="blank">
        <SiGooglemaps size={40}/>
        </a>
      </div>
      <p className="">77/2 Võ Thị Hồi, Xuân Thới Đông, Hóc Môn, Hồ Chí Minh.</p>
    
      <iframe
        title="address"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3918.277513057087!2d106.59467307673862!3d10.866484657522621!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752a6eda59f88d%3A0x8b49afa7f87dd7d9!2zNzcgxJAuIFbDtSBUaOG7iyBI4buTaSwgWHXDom4gVGjhu5tpIMSQw7RuZywgSMOzYyBNw7RuLCBI4buTIENow60gTWluaCwgVmlldG5hbQ!5e0!3m2!1sen!2sus!4v1743306976888!5m2!1sen!2sus"
        width="250"
        height="400"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        className="border-none"
      />
    </div>
    </>
  )
}

export default Contact